export const useShare = () => {
  alert('Share action')
}
